module.exports = __webpack_public_path__ + "static/media/arrow-pointing-to-up.6709e380.svg";